import { mount } from "svelte";
import Index from "./index.svelte";

// Svelte 5 client mount (runes mode). Plain Svelte, no SvelteKit.
const index = mount(Index, {
  target: document.body,
});

export default index;
